'use client';

import React from 'react';

import { CMSLink } from '@/components/Link';
import { NAV } from '@/constants';
import { cn } from '@/utilities/cn';

export const LinkToServices: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <CMSLink className={cn('relative block', className)} url={NAV.serviceList}>
      <svg
        className="w-[120px] lg:w-[88px]"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M119 60C119 71.6691 115.54 83.0761 109.057 92.7786C102.574 102.481 93.3592 110.043 82.5783 114.509C71.7975 118.974 59.9346 120.143 48.4897 117.866C37.0448 115.59 26.532 109.971 18.2807 101.719C10.0294 93.468 4.4102 82.9552 2.13367 71.5103C-0.14286 60.0654 1.02554 48.2025 5.49111 37.4217C9.95668 26.6408 17.5189 17.4263 27.2214 10.9433C36.9239 4.46029 48.3309 1 60 1"
          stroke="#3E6ED4"
          strokeWidth="2"
        />
        <path d="M48 48H72V72" stroke="#3E6ED4" strokeWidth="3" />
        <path d="M48 72L72 48" stroke="#3E6ED4" strokeWidth="3" />
      </svg>

      <span className="h7 lg:text-mobile-h7 text-blue link-secondary absolute top-[-2px] left-[88px] lg:top-0 lg:left-[52px]">
        Медицинские
        <br />
        услуги
      </span>
    </CMSLink>
  );
};
